import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormErrorModule } from '@feature/forms/form-error/form-error.module';

import { FormToggleComponent } from './form-toggle.component';

export const imports: NgModule['imports'] = [
  FlexLayoutModule,
  FormErrorModule,
  MatFormFieldModule,
  MatIconModule,
  MatSlideToggleModule,
  ReactiveFormsModule,
];

@NgModule({
  declarations: [FormToggleComponent],
  imports: [...imports, CommonModule],
  exports: [FormToggleComponent],
})
export class FormToggleModule {}
